(() => {
  const initialized = new WeakSet();
  function init(root = document) {
    root.querySelectorAll('.fo-selection').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const track = section.querySelector('.fo-selection__track');
      const prev = section.querySelector('[data-fo-selection-step="-1"]');
      const next = section.querySelector('[data-fo-selection-step="1"]');
      if (!track || !prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
      };
      [prev, next].forEach(button => button.addEventListener('click', () => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: Number(button.dataset.foSelectionStep) * (track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
